/*
 * Website: https://www.4myth.com
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Copyright © 2016-2022 All rights reserved.
 * MyTh Ahmed Fayez
 */

export default {
  title: 'إنشاء حساب جديد',
  subtitle: 'قم بإنشاء حسابك الآن',
  have_account: 'لديك حساب بالفعل؟ '
}
